module.exports = __webpack_public_path__ + "static/media/realtors-icon-15.dc0a474d.svg";